import React, { useEffect, useState } from "react";
import AppDrawer from "../Navbar/AppDrawer";
import { SERVER_IP, PORT, ud, jwt, auth_response_flow, LICENSE } from "../Server";
import axios from "axios";
import user_img from "../assets/images/user/user.svg";
import { logout } from "../Server";
import ralogo from "../assets/images/RemoteAssist.png";
import { SignOutIcon } from "../assets/Icons";

var simulanisimg = ud && ud.profile_logo ? ud.profile_logo : user_img;

const HeaderMobile = () => {
  const handleLogOut = () => {
    logout.logout();
  };

   const name = ud?.username || "User";
   const designation = ud?.designation || "Member";
   const email = ud?.email || "user@example.com";
   const image = ud?.profile_logo || user_img;
   const placeholderUserName = name
     ?.split(" ")
     ?.slice(0, 2)
     ?.map((e) => e.charAt(0)?.toUpperCase())
     ?.join("");

  const [lastScrollTop, setLastScrollTop] = useState(0);
   const [scrollDirection, setScrollDirection] = useState(null);
useEffect(() => {
  const handleScroll = () => {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop === 0) {
      setScrollDirection("scroll-default");
    } else if (scrollTop > lastScrollTop) {
      setScrollDirection("up");
    } else if (scrollTop < lastScrollTop) {
      setScrollDirection("down");
    }

    setLastScrollTop(scrollTop <= 0 ? 0 : scrollTop);
  };

  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, [lastScrollTop]);

  return (
    <>
      <div
        className={`xp-topbar ${
          scrollDirection === "up" ? "scroll-up" : scrollDirection === "down" ? "scroll-down" : "scroll-default"
        }`}
      >
        <div className="row">
          <div className="col-3">
            <div className="thumb">
              <a href="#">
                <span className="logoimg">
                  <img src={ralogo} className="img-fluid" alt="logo" />
                </span>
              </a>
            </div>
          </div>
          <div className="col-9">
            <div className="d-flex justify-content-end gap-1">
              <div className="dropdown xp-userprofile">
                <div
                  className="profile-info dropdown-toggle"
                  data-toggle="dropdown" // Bootstrap 4 syntax
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  {!image ? (
                    <img src={image} referrerPolicy="no-referrer" alt="User" className="rounded-circle img-fluid" />
                  ) : (
                    <span className="placeholder">{placeholderUserName}</span>
                  )}
                  <span className="xp-user-live" />
                </div>

                <div className="dropdown-menu profile-detail-parent p-0">
                  <div className="profile-detail">
                    <div className="bg">
                      {image ? (
                        <img src={image} referrerPolicy="no-referrer" alt="User" />
                      ) : (
                        <span>{placeholderUserName}</span>
                      )}
                    </div>
                    <span className="name-email">
                      <p>{name}</p>
                      <p className="email">{email}</p>
                      <p className="designation">{designation}</p>
                    </span>
                    <span className="signout" onClick={logout.logout}>
                      <SignOutIcon />
                      Sign Out
                    </span>
                  </div>
                </div>
              </div>

              <AppDrawer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default HeaderMobile;
